import axiosInstance from '@server/axiosInstance';
import { deleteCookie, getCookie, setCookie } from '@utils/getCookie';
import { Dispatch, SetStateAction } from 'react';


type useLoagoutProps = {
    setLoading: Dispatch<SetStateAction<Boolean>>;
};

export const useLogout = async ({ setLoading }: useLoagoutProps) => {
    try {
        setLoading(true);
        // Call the logout API endpoint using Axios
        const response = await axiosInstance.get('/logout');
        if (response.data.status === 200) {
            // Delete specific cookies
            setCookie('SU_AUTH', null, 0)
            setCookie('master_key', null, 0)
            setCookie('sessionid', null, 0)
            setCookie('inboxChecked', null, 0)
            setCookie('calendarSyncRead', null, 0)
            setCookie('isNotificationPopupShown', null, 0)
            setCookie('dontShowWarningPopup', null, 0)
            setCookie('hideJobClosedSuggestion', null, 0)
            setCookie('SU_USER_TYPE', null, 0)
            deleteCookie('SU_AUTH');
            deleteCookie('master_key');
            deleteCookie('sessionid');
            deleteCookie('inboxChecked');
            deleteCookie('calendarSyncRead');
            deleteCookie('isNotificationPopupShown');
            deleteCookie('dontShowWarningPopup');
            deleteCookie('hideJobClosedSuggestion');
            deleteCookie('SU_USER_TYPE');
            sessionStorage.removeItem('hireflixModalSeen');
            // Get all cookies
            const allCookies = document.cookie.split(';');
            // Iterate through all cookies
            allCookies.forEach(cookie => {
                const cookieName = cookie.split('=')[0].trim();
                if (cookieName !== 'sessionid') {
                    deleteCookie(cookieName);
                }
            });
            setLoading(false)
            // Redirect to marketing site URL
            window.location.href = import.meta.env.VITE_MARKETING_SITE_URL;
        }

    } catch (error) {
        setLoading(false)
        console.error('Error during logout:', error);
        throw error;
    }
};
